import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  Select,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
export default function PaymentDateModal({
  isOpen,
  onClose,
  func,
}: any) {
  // const [value, setValue] = useState(Data.filterType);
  // const [lock, setLock] = useState(isLock);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const initialRef = React.useRef(null);

  const  convertToUnixTimestamp = (dateString:string) =>{
    if (!dateString) {
      
      return null;
    }

    const dateObject = new Date(dateString + "T00:00:00+05:30");

    if (isNaN(dateObject.getTime())) {
      return null;
    }

    const unixTimestampMilliseconds = dateObject.getTime();

    const unixTimestampSeconds = Math.floor(unixTimestampMilliseconds / 1000);
  
    return unixTimestampSeconds;
  }

  const handleSubmit = () => {
    func(convertToUnixTimestamp(fromDate),convertToUnixTimestamp(toDate))
    onClose();
  }
  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Choose Date Range</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl >
              <FormLabel>From</FormLabel>
              <Input
                value={fromDate}
                type="date"
                ref={initialRef}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </FormControl>

            <FormControl mt={2}>
              <FormLabel>To</FormLabel>
              <Input
                value={toDate}
                type="date"
                ref={initialRef}
                onChange={(e) => setToDate(e.target.value)}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
         
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={handleSubmit}
            >
              Submit
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

//PaymentDateModal
